import React from "react";
import {
  FaRocket, FaWhatsapp, FaArrowLeft, FaTimes, FaClock, FaSignal,
  FaChalkboardTeacher, FaCertificate, FaListUl, FaGraduationCap,
  FaInfoCircle, FaUserTie, FaUser, FaCheckCircle, FaArrowRight,
  FaEnvelope,  FaMapMarkerAlt, FaTrophy
} from "react-icons/fa";

const CourseDetailsCard = ({
  course,
  style = {
    color: "from-blue-500 to-purple-600",
    bgColor: "bg-blue-50",
    icon: "fas fa-graduation-cap"
  }, 
  getCourseBenefits,
  getCoursePrerequisites,
  getInstructorInfo, 
  registerCourse,
  registerCourseNoSubscripption,
  backToCourses,
  closeModal,
}) => {
  console.log("course detail",course)
  // Course data with defaults
  const courseData = {

    instructor_name: course.instructor_name,
    instructor_email: course.instructor_email,
    instructor_wilaya: course.instructor_wilaya,
    instructor_bio: course.instructor_bio,
    instructor_achievements: course.instructor_achievements,

    duree:course.duree,
    prerequis:course.prerequis,
    id: course.id,
    name: course.name || course.title || "Sans titre",
    description: course.description || "Aucune description disponible",
    price: course.price ? `${course.price} ` : "Gratuit",
    duration: course.duree || course.duration || "Non spécifiée",
    level: course.niveau || course.level || "N/A",  
    instructor: course.instructor || "Professeur",
    certificat: course.certificat || "Incluse",
    programme: course.programme || course.content || [],
    learn: course.learn || ""
  };
  console.log("courseData",courseData)

  // Default functions
  const defaultGetCourseBenefits = (courseId) => {
    const currentCourse = courseData;
    if (currentCourse.learn) {
      return currentCourse.learn.split('\n').filter(item => item.trim() !== '');
    }
    return [
      "Maîtriser les concepts fondamentaux",
      "Acquérir des compétences pratiques",
      "Développer une expertise professionnelle"
    ];
  };

  const defaultGetCoursePrerequisites = (courseId) => {
    const currentCourse = courseData;
    if (currentCourse.prerequis) {
      return currentCourse.prerequis.split('\n').filter(item => item.trim() !== '');
    }
    return ["Aucun prérequis nécessaire", "Motivation et envie d'apprendre"];
  };



  // Use provided functions or defaults
  const benefits = getCourseBenefits ? getCourseBenefits(courseData.id) : defaultGetCourseBenefits(courseData.id);
  const prerequisites = getCoursePrerequisites ? getCoursePrerequisites(courseData.id) : defaultGetCoursePrerequisites(courseData.id);
  const instructorInfo = getInstructorInfo ? getInstructorInfo(courseData.id) : courseData.instructor;

  return (
    <div className="space-y-8 p-6">
      {/* Hero Section */}
      <div className={`relative overflow-hidden rounded-2xl bg-gradient-to-r ${style.color} text-white p-8`}>
        <div className="absolute top-0 right-0 w-32 h-32 bg-white opacity-10 rounded-full transform translate-x-8 -translate-y-8"></div>
        <div className="absolute bottom-0 left-0 w-24 h-24 bg-white opacity-10 rounded-full transform -translate-x-4 translate-y-4"></div>

        <div className="relative z-10">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between mb-6 gap-4">
            <div className="flex items-center">
              <div className="w-16 h-16 bg-white bg-opacity-20 rounded-xl flex items-center justify-center mr-4">
                <FaGraduationCap className="text-2xl" />
              </div>
              <div>
                <h3 className="text-2xl font-bold">{courseData.name}</h3>
                <p className="opacity-90">Formation professionnelle complète</p>
              </div>
            </div>
            <div className="text-center lg:text-right">
              <div className="text-3xl font-bold">{courseData.price}</div>
              <div className="text-sm opacity-80">Prix de lancement</div>
            </div>
          </div>
          <p className="text-lg opacity-95">{courseData.description}</p>
        </div>
      </div>

      {/* Info Cards */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {[
          { icon: FaClock, label: "Durée", value: courseData.duration },
          { icon: FaSignal, label: "Niveau", value: courseData.level },
          { icon: FaChalkboardTeacher, label: "Instructeur", value: instructorInfo.name },
          { icon: FaCertificate, label: "Certification", value: courseData.certificat },
        ].map((info, i) => (
          <div key={i} className={`${style.bgColor} rounded-xl p-4 text-center`}>
            <info.icon className="text-2xl text-gray-600 mb-2 mx-auto" />
            <h4 className="font-bold text-gray-800 mb-1 text-sm">{info.label}</h4>
            <p className="text-gray-600 text-sm">{info.value}</p>
          </div>
        ))}
      </div>

      {/* Programme Section */}
      {courseData.programme && courseData.programme.length > 0 && (
        <div className="bg-white rounded-2xl shadow-lg p-6">
          <h3 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
            <FaListUl className="mr-3 text-blue-600" />
            Programme de formation
          </h3>
          <div className="space-y-4">
            {courseData.programme.map((item, index) => (
              <div key={index} className="flex items-start space-x-4 p-4 rounded-lg border border-gray-200 hover:bg-gray-50 transition">
                <div className={`w-8 h-8 bg-gradient-to-r ${style.color} rounded-full flex items-center justify-center text-white font-bold text-sm flex-shrink-0 mt-1`}>
                  {index + 1}
                </div>
                <div className="flex-1">
                  <h4 className="font-semibold text-gray-800">
                    {item.chapter || item.name || `Chapitre ${index + 1}`}
                  </h4>
                  <p className="text-sm text-gray-600 mt-1">
                    {item.description || "Module pratique avec exercices"}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* What You'll Learn */}
      <div className="bg-gradient-to-r from-gray-50 to-gray-100 rounded-2xl p-6">
        <h3 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
          <FaGraduationCap className="mr-3 text-green-600" />
          Ce que vous apprendrez
        </h3>
        <div className="grid md:grid-cols-2 gap-4">
          {benefits.map((benefit, i) => (
            <div key={i} className="flex items-center space-x-3">
              <FaCheckCircle className="text-green-500 flex-shrink-0" />
              <span className="text-gray-700">{benefit}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Prerequisites */}
      <div className="bg-blue-50 rounded-2xl p-6">
        <h3 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
          <FaInfoCircle className="mr-3 text-blue-600" />
          Prérequis
        </h3>
        <div className="space-y-3">
          {prerequisites.map((req, i) => (
            <div key={i} className="flex items-center space-x-3">
              <FaArrowRight className="text-blue-500 flex-shrink-0" />
              <span className="text-gray-700">{req}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Enhanced Instructor Section */}
      <div className="bg-white rounded-2xl shadow-lg p-6">
        <h3 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
          <FaUserTie className="mr-3 text-purple-600" />
          Votre formateur
        </h3>
        <div className="flex flex-col lg:flex-row gap-6">
          {/* Instructor Photo/Icon */}
          <div className="flex flex-col items-center">
            <div className={`w-24 h-24 bg-gradient-to-r ${style.color} rounded-full flex items-center justify-center text-white text-3xl mb-4`}>
              <FaUser />
            </div>
            <h4 className="text-xl font-bold text-gray-800 text-center">{instructorInfo.name || courseData.instructor_name}</h4>
          </div>

          {/* Instructor Details */}
          <div className="flex-1">
            {/* Contact Information */}
            <div className="grid md:grid-cols-2 gap-4 mb-6">
              <div className="flex items-center space-x-3 text-gray-600">
                <FaEnvelope className="text-blue-500" />
                <span>{instructorInfo.email || courseData.instructor_email}</span>
              </div>
              <div className="flex items-center space-x-3 text-gray-600">
                <FaMapMarkerAlt className="text-red-500" />
                <span>{instructorInfo.wilaya || courseData.instructor_wilaya}</span>
              </div>
            </div>

            {/* Bio */}
            <p className="text-gray-600 mb-6 leading-relaxed">{instructorInfo.bio || courseData.instructor_bio}</p>

            {/* Achievements */}
            <div>
              <h5 className="font-semibold text-gray-800 mb-3 flex items-center">
                <FaTrophy className="mr-2 text-yellow-500" />
                Réalisations & Certifications
              </h5> 
             <div className="flex flex-wrap gap-2">
  {/* First priority: instructorInfo.achievements */}
  {Array.isArray(instructorInfo?.achievements) &&
    instructorInfo.achievements.length > 0 ? (
      instructorInfo.achievements.map((achievement, index) => (
        <span
          key={index}
          className="bg-purple-100 text-purple-800 px-3 py-1 rounded-full text-sm"
        >
          {achievement}
        </span>
      ))
  ) : instructorInfo?.achievements ? (
    // Exists but is NOT an array
    <span className="bg-purple-100 text-purple-800 px-3 py-1 rounded-full text-sm">
      {instructorInfo.achievements}
    </span>
  ) : null}

  {/* Second priority: courseData.instructor_achievements */}
  {Array.isArray(courseData?.instructor_achievements) &&
    courseData.instructor_achievements.length > 0 ? (
      courseData.instructor_achievements.map((achievement, index) => (
        <span
          key={`course-${index}`}
          className="bg-purple-100 text-purple-800 px-3 py-1 rounded-full text-sm"
        >
          {achievement}
        </span>
      ))
  ) : courseData?.instructor_achievements ? (
    // Exists but NOT an array
    <span className="bg-purple-100 text-purple-800 px-3 py-1 rounded-full text-sm">
      {courseData.instructor_achievements}
    </span>
  ) : null}
</div>

            </div>
          </div>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="flex flex-col sm:flex-row gap-4">
        <button 
           onClick={() => registerCourse(courseData.name,courseData.id, )}
          className={`bg-gradient-to-r ${style.color} text-white px-6 py-4 rounded-xl font-bold text-lg flex-1 hover:shadow-lg transform hover:scale-105 transition-all duration-300 flex items-center justify-center`}
        >
          <FaRocket className="mr-2" /> S'inscrire maintenant
        </button>

        <button
          onClick={() => registerCourseNoSubscripption(courseData.name,courseData.id)}
          className="border-2 border-gray-300 text-gray-600 px-6 py-4 rounded-xl font-semibold hover:bg-gray-50 transition flex items-center justify-center"
        >
          <FaWhatsapp className="mr-2" /> Questions ?
        </button>

        {backToCourses && (
          <button
            onClick={backToCourses}
            className="bg-blue-600 text-white px-6 py-4 rounded-xl font-semibold hover:bg-blue-700 transition flex items-center justify-center"
          >
            <FaArrowLeft className="mr-2" /> Retour
          </button>
        )}

        {closeModal && (
          <button
            onClick={closeModal}
            className="border-2 border-gray-300 text-gray-600 px-6 py-4 rounded-xl font-semibold hover:bg-gray-50 transition flex items-center justify-center"
          >
            <FaTimes className="mr-2" /> Fermer
          </button>
        )}
      </div>
    </div>
  );
};

export default CourseDetailsCard; 